import * as Sentry from "@sentry/react";


const isErrorObject = (obj) => obj && obj.stack && obj.message
const tryToSafelyStringify = (obj) => {
    try {
        return JSON.stringify(obj)
    } catch (e) {
        console.log(e);
    }
}

export const ErrorService = {
    handleError(e, hint) {
        try {
            /* Report to Sentry with optional context from hint.data */
            if (hint?.data) {
                Sentry.withScope((scope) => {
                    // Add structured tags for filtering in Sentry
                    Object.entries(hint.data).forEach(([key, value]) => {
                        if (value !== undefined && value !== null && typeof value !== 'object') {
                            scope.setTag(key, String(value))
                        } else if (value && typeof value === 'object') {
                            // Objects go as extra data (visible in Sentry "Additional Data")
                            scope.setExtra(key, value)
                        }
                    })
                    Sentry.captureException(e, hint)
                })
            } else {
                Sentry.captureException(e, hint)
            }
        } catch (veryBadError) {
            console.error(veryBadError);
        }
    }
}